export enum URLS {
    me = 'me',
    login = 'login',
    activate = 'activate',
    reset_send = 'reset_send',
    reset_change = 'reset_change',
    create_users = 'create_users',
    create_admin = 'create_admin',
    users = 'users',
    users_by_id = 'users_by_id',
    update_password = 'update_password',
    update_login = 'update_login',
    update_by_id = 'update_by_id',
}

export const getUrls = (params: { id?: string; name: URLS }) => {
    const { id, name } = params;

    switch (name) {
        case URLS.me:
            return `/me`;
        case URLS.login:
            return '/auth/login';
        case URLS.activate:
            return '/auth/activate';
        case URLS.reset_send:
            return '/auth/reset/send';
        case URLS.reset_change:
            return '/auth/reset/change';
        case URLS.create_users:
            return '/users/create';
        case URLS.create_admin:
            return '/users/create/admin';
        case URLS.users:
            return '/users';
        case URLS.users_by_id:
            return `/users/${id}`;
        case URLS.update_password:
            return '/users/update/password';
        case URLS.update_login:
            return '/users/update/login';
        case URLS.update_by_id:
            return `/users/update/${id}`;

        default:
            break;
    }
};

export enum COMPANIES_URLS {
    create = 'create',
    companies = 'companies',
    invite = 'invite',
    remove = 'remove',
    company = 'company',
    users = 'users',
    update = 'update',
    delete = 'delete',
}

type TCompaniesParamsRequest = {
    companyId?: string;
    reqName: COMPANIES_URLS;
};

export const getCompaniesUrls = (params: TCompaniesParamsRequest) => {
    const { companyId, reqName } = params;

    switch (reqName) {
        case COMPANIES_URLS.create:
            return '/companies/create';
        case COMPANIES_URLS.companies:
            return '/companies';
        case COMPANIES_URLS.invite:
            return `/companies/${companyId}/invite`;
        case COMPANIES_URLS.remove:
            return `/companies/${companyId}/remove`;
        case COMPANIES_URLS.company:
            return `/companies/${companyId}`;
        case COMPANIES_URLS.users:
            return `/companies/${companyId}/users`;
        case COMPANIES_URLS.update:
            return `/companies/${companyId}/update`;
        case COMPANIES_URLS.delete:
            return `/companies/${companyId}/delete`;
        default:
            break;
    }
};

export enum TEAMS_URLS {
    create_team = 'create_team',
    teams = 'teams',
    team = 'team',
    team_agents = 'team_agents',
    invite_member = 'invite_member',
    remove_member = 'remove_member',
    update_team = 'update_team',
    delete_team = 'delete_team',
    update_variables = 'update_variables',
    roles = 'roles',
    update_roles = 'update_roles',
    upload_query = 'upload_query',
    upload_users = 'upload_users',
    upload_leads = 'upload_leads',
    timeframe = 'timeframe',
    summary = 'summary',
}

type TTeamsParamsRequest = {
    companyId?: string;
    id?: string;
    agentId?: string;
    reqName: TEAMS_URLS;
};

export const getTeamsUrls = (params: TTeamsParamsRequest) => {
    const { companyId, id, agentId, reqName } = params;

    switch (reqName) {
        case TEAMS_URLS.create_team:
            return `/companies/${companyId}/teams/create`;
        case TEAMS_URLS.teams:
            return `/companies/${companyId}/teams`;
        case TEAMS_URLS.team:
            return `/companies/${companyId}/teams/${id}`;
        case TEAMS_URLS.team_agents:
            return `/companies/${companyId}/teams/${id}/agents`;
        case TEAMS_URLS.invite_member:
            return `/companies/${companyId}/teams/invite`;
        case TEAMS_URLS.remove_member:
            return `/companies/${companyId}/teams/remove`;
        case TEAMS_URLS.update_team:
            return `/companies/${companyId}/teams/update/${id}`;
        case TEAMS_URLS.delete_team:
            return `/companies/${companyId}/teams/delete/${id}`;
        case TEAMS_URLS.update_variables:
            return `/companies/${companyId}/teams/variables/update`;
        case TEAMS_URLS.roles:
            return `/companies/${companyId}/roles`;
        case TEAMS_URLS.update_roles:
            return `/companies/${companyId}/roles/update`;
        case TEAMS_URLS.upload_query:
            return `/companies/${companyId}/upload/query`;
        case TEAMS_URLS.upload_users:
            return `/companies/${companyId}/upload/users`;
        case TEAMS_URLS.upload_leads:
            return `/companies/${companyId}/upload/leads`;
        case TEAMS_URLS.timeframe:
            return `/companies/${companyId}/agent/${agentId}/timeframe`;
        case TEAMS_URLS.summary:
            return `/companies/${companyId}/agent/${agentId}/summary`;

        default:
            break;
    }
};
